/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Tool_Grants_Admin_NoteInputs */



/**
* | output |
* | --- |
* | "Admins may use every tool." |
*
* @param {Spaces_Tool_Grants_Admin_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_tool_grants_admin_note = /** @type {((inputs?: Spaces_Tool_Grants_Admin_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Tool_Grants_Admin_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Admins dürfen alle Tools verwenden.")
	return /** @type {LocalizedString} */ ("Admins may use every tool.")
});